import { render, staticRenderFns } from "./xePeekCard.vue?vue&type=template&id=55132bb3&scoped=true"
import script from "./xePeekCard.vue?vue&type=script&lang=js"
export * from "./xePeekCard.vue?vue&type=script&lang=js"
import style0 from "./xePeekCard.vue?vue&type=style&index=0&id=55132bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55132bb3",
  null
  
)

export default component.exports